import { FC } from 'react'
import { Content } from '@/client/components'
export const BlogContent: FC<any> = ({ content }) => <Content content={content} />
